<script lang="ts">
	import heroImg from "../assets/images/brano-areal-view-colored.png?webp&w=1920&imagetools";
	import { getTenant } from "../contexts/tenantContextKey.js";
	import { getEsgStrategyAreas } from "./esgStrategyAreas.js";
	import StaticPicture from "./Picture/StaticPicture.svelte";
	import { getPathInLocale } from "../../../core/schema/paths/getPathInLocale.js";
	import { esgStrategyPathMap } from "../../../core/schema/paths/esgStrategyPathMap.js";
	import arrowRight from "../../../core/assets/icons/arrowRight.svg?raw";
	import Icon from "./Icon.svelte";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import { nbspifyHtml } from "../../../core/utils/nbspifyHtml.js";

	const { locale } = getTenant();

	const areas = getEsgStrategyAreas(locale);
	/* eslint-disable svelte/no-at-html-tags */
</script>

<div class="relative overflow-clip lg:pb-96">
	<StaticPicture
		image={heroImg}
		class="absolute bottom-0 left-0 right-0 -z-10 hidden lg:block"
		imgClass="object-cover !w-full max-h-full"
		width={1920}
		height={888}
		alt=""
	/>

	<div class="flex grid-cols-3 grid-rows-[auto,auto] flex-col lg:container lg:grid">
		{#each areas as area (area.id)}
			<div class="row-span-full flex grid-rows-subgrid flex-col lg:grid">
				<a
					href="/{getPathInLocale(locale, esgStrategyPathMap)}#{area.id}"
					class="group relative grid aspect-square grid-cols-[auto,auto] grid-rows-[1fr,auto] p-8 text-white max-lg:max-h-[37.5rem] lg:p-16"
				>
					<span class="lg:1text-2md text-[1.125rem] font-light">ESG</span>
					<span></span>
					<span class="lg:text-2lg self-end text-[1.75rem] font-bold">{nbspify(area.name)}</span>
					<Icon class="mb-3 h-6 self-end justify-self-end" icon={arrowRight} />
					<StaticPicture
						image={area.image}
						class="absolute inset-0 -z-10"
						imgClass="!h-full !w-full object-cover"
						alt={area.name}
						width={580}
						height={580}
					/>
					<div class="absolute inset-0 -z-10 bg-black/50 transition-colors group-hover:bg-black/65"></div>
				</a>
				<div class="max-lg:container">
					<ul class="flex h-full flex-col gap-8 bg-white px-8 py-16 lg:p-14">
						{#each area.points as point}
							<li class="lg:text-2md text-[1.125rem] font-light">{@html nbspifyHtml(point)}</li>
						{/each}
					</ul>
				</div>
			</div>
		{/each}
	</div>

	<slot name="below-cards"></slot>
</div>
